import { getListagemMunicipios } from "@/services/api/rotas";
import { useQuery } from "@tanstack/react-query";
import { useWebgate } from "@xvia/webgate-connect";
export const useGetListagemMunicipios = () => {
    const { accessToken } = useWebgate();
    return useQuery({
        queryKey: ["listagem-municipios"],
        queryFn: () => getListagemMunicipios(accessToken),
        enabled: true,
        refetchOnWindowFocus: true,
    });
};
